module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/cmd-f73b9416ef0802366caf37213a091cc2.svg";